import CRTFilter from '../../utils/CRTShaderFX'

const config = {
  preload() {
    // this is scene binded by RPF
    this.load.spritesheet(
      "hud",
      process.env.PUBLIC_URL + "/assets/tilemaps/hud_tilemap_20x20.png",
      { frameWidth: 20, frameHeight: 20, margin: 1, sapcing: 2 }
    );
  },
  create() {
    this.cameras.main.setPostPipeline(CRTFilter);
  }
};

export default config
